import { render, staticRenderFns } from "./sendNewYearCardNextStep.vue?vue&type=template&id=7babe4e4"
import script from "./sendNewYearCardNextStep.vue?vue&type=script&lang=js"
export * from "./sendNewYearCardNextStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7babe4e4')) {
      api.createRecord('7babe4e4', component.options)
    } else {
      api.reload('7babe4e4', component.options)
    }
    module.hot.accept("./sendNewYearCardNextStep.vue?vue&type=template&id=7babe4e4", function () {
      api.rerender('7babe4e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/common/sendNewYearCardNextStep.vue"
export default component.exports